import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import logo from "../img/logo.jpeg";
import AreaList from "../common/Area-list";

const Nav = () => {
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

    return (
        <header className="header_section">
            <div className="header_top">
                <div className="container-fluid">
                    <div className="contact_nav">
                        <div style={{ display: "flex", gap: "10px" }}>
                            <Link to="tel:+01123455678990">
                                <FontAwesomeIcon icon={faPhone} />
                                <span> +1 408-215-6348  </span>
                            </Link>
                            <Link to="mailto:info@goldenstatemover.com">|
                                <FontAwesomeIcon icon={faEnvelope} />
                                <span> info@goldenstatemover.com </span>
                            </Link>
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <Link to="/">
                                <FontAwesomeIcon icon={faMapMarkerAlt} />
                                <span> 9361 Jackson Road, Sacramento  CA 95826 </span>
                            </Link> 
                            <Link to="/">|
                                <FontAwesomeIcon icon={faMapMarkerAlt} />
                                <span> 1859 Masuda Landing, San Jose CA 95132 </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="header_bottom">
                <div className="container">
                    <nav className="navbar navbar-expand-lg custom_nav-container">
                        <Link className="navbar-brand" to="/"><img src={logo} /></Link>
                        <button className="navbar-toggler" onClick={handleNavCollapse} aria-controls="navbarSupportedContent" aria-expanded={!isNavCollapsed} ><span className="navbar-toggler-icon"></span></button>

                        <div className={`navbar-collapse ${isNavCollapsed ? "collapse" : ""}`} id="navbarSupportedContent">
                            <ul className="navbar-nav">
                                <li className="nav-item active">
                                    <Link className="nav-link" to="/"> Home <span className="sr-only">(current)</span> </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/services">Services</Link>
                                    <ul className="dropDownNew">
                                        <li><Link to="/local-moving">Local Moving</Link></li>
                                        <li><Link to="/long-distance-moving">Long Distance Moving</Link></li>
                                        <li><Link to="/commercial-moving">Commercial Moving</Link></li>
                                        <li><Link to="/full-packing">Full Packing</Link></li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link">Area Served</Link>
                                    <ul className="dropDownNew">
                                        <AreaList />
                                    </ul>
                                </li>
                                <li className="nav-item"><Link className="nav-link" to="/moving-tips">Moving Tips</Link></li>
                                <li className="nav-item">
                                    <Link className="nav-link">About</Link>
                                    <ul className="dropDownNew">
                                        <li><Link to="/about">About Us</Link></li>
                                        <li><Link to="/contact">Contact Us</Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </header >
    );
};

export default Nav;
